module.exports = __webpack_public_path__ + "static/img/26.8140322a.png";